import { Badge, DialogTitle } from "@mui/material";
import React, { useEffect, useState } from "react";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { DeleteNotifications, GetNotifications } from "../../Services/Notification";
import { CircularProgress } from '@mui/material';
import { useTranslation } from "react-i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const Notifications: React.FunctionComponent<{}> = (props) => {

    const [notification, setNotification] = useState<any>(null);
    const [count, setCount] = useState<any>(0);
    const [open, setOpen] = React.useState(false);
    const [videoUrl, setVideoUrl] = React.useState<any>(null);
    const [isVideoLoading, setIsVideoLoading] = useState(true);
    const [change, setChange] = useState<boolean>(false);
    const { t } = useTranslation();

    // useEffect(() => {
    //     const socket = new WebSocket('ws://localhost:8080');
    //     socket.onopen = () => {
    //         // console.log('WebSocket connection established');
    //         socket.send(JSON.stringify({ type: 'auth', token: localStorage.getItem("usertoken") }));
    //     };
    //     socket.onmessage = (event) => {
    //         const data = JSON.parse(event.data);
    //         if (data.type === 'connection-established') {
    //             // Send authentication token
    //             socket.send(JSON.stringify({
    //                 type: 'authenticate',
    //                 token: localStorage.getItem("usertoken") // Or however you store your token
    //             }));
    //         }
    //         // Handle new notifications
    //         if (data.type === 'initial-notifications') {
    //             setNotification(data.data);
    //             setCount(data.data.count)
    //         }
    //         if (data.type === 'new-notification') {
    //             setNotification(data.data);
    //             setCount(data.data.count)
    //         }
    //     };

    //     socket.onerror = (error) => {
    //         console.error('WebSocket error:', error);
    //     };

    //     return () => socket.close();
    // }, []);

    useEffect(() => {
        const interval = setInterval(fetchData, 4000);
        return () => {
            clearInterval(interval);
        };
    }, [change]);

    const fetchData = async () => {
        GetNotifications().then((resp) => {
            setNotification(resp.data);
            setCount(resp.data.count)
        }).catch((error) => {
            console.log("error")
        });
    };

    const convertDate = (date: any) => {
        const dateTime = new Date(date);
        const hours = dateTime.getHours();
        const minutes = dateTime.getMinutes().toString().padStart(2, '0');
        const day = dateTime.getDate().toString().padStart(2, '0');
        const month = (dateTime.getMonth() + 1).toString().padStart(2, '0');
        const year = dateTime.getUTCFullYear().toString();
        const formattedDate = `${hours}:${minutes}, ${day}/${month}/${year}`;
        return formattedDate;
    };

    const handleClose = () => {
        setOpen(false);
        setVideoUrl(null)
        DeleteNotifications(videoUrl.id).then((resp) => {
            setChange(!change)
        }).catch((error) => {
            console.log("error")
        })
    };

    const readNotificationsVideo = (video: any) => {
        setVideoUrl(video)
        setOpen(true);
    }

    const HandleDownoald = () => {
        try {
            const a = document.createElement('a');
            a.href = videoUrl.url;
            a.download = 'generated_video.mp4';
            a.click();
        } catch (error) {
            console.error('Error Download:', error);
        }
    }

    return (<>
        <span data-bs-toggle="dropdown" className="card-item-notif" aria-expanded="false" style={{ cursor: "pointer" }}>
            {(count === '0') ?
                <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.4" d="M17.7283 13.7824L16.8117 12.2607C16.6192 11.9215 16.445 11.2799 16.445 10.904V8.58487C16.445 5.59654 14.0158 3.1582 11.0183 3.1582C8.02083 3.1582 5.59167 5.59654 5.59167 8.58487V10.904C5.59167 11.2799 5.4175 11.9215 5.225 12.2515L4.29917 13.7824C3.9325 14.3965 3.85 15.0749 4.07917 15.6982C4.29917 16.3124 4.82167 16.789 5.5 17.0182C7.27833 17.6232 9.14833 17.9165 11.0183 17.9165C12.8883 17.9165 14.7583 17.6232 16.5367 17.0274C17.1783 16.8165 17.6733 16.3307 17.9117 15.6982C18.15 15.0657 18.0858 14.369 17.7283 13.7824Z" fill="#64748B" />
                    <path d="M13.0616 3.5435C12.4291 3.296 11.7416 3.1585 11.0174 3.1585C10.3024 3.1585 9.61492 3.28683 8.98242 3.5435C9.37659 2.801 10.1558 2.3335 11.0174 2.3335C11.8883 2.3335 12.6583 2.801 13.0616 3.5435Z" fill="#64748B" />
                    <path d="M13.5932 18.8427C13.2082 19.906 12.1907 20.6668 10.9991 20.6668C10.2749 20.6668 9.5599 20.3735 9.05573 19.851C8.7624 19.576 8.5424 19.2093 8.41406 18.8335C8.53323 18.8518 8.6524 18.861 8.78073 18.8793C8.99156 18.9068 9.21156 18.9343 9.43156 18.9527C9.95406 18.9985 10.4857 19.026 11.0174 19.026C11.5399 19.026 12.0624 18.9985 12.5757 18.9527C12.7682 18.9343 12.9607 18.9252 13.1441 18.8977C13.2907 18.8793 13.4374 18.861 13.5932 18.8427Z" fill="#64748B" />
                    <circle cx="16.621" cy="4.87878" r="3.12097" fill="#10B981" stroke="white" />
                </svg>
                : <Badge badgeContent={count} color="secondary">
                    <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.4" d="M17.7283 13.7824L16.8117 12.2607C16.6192 11.9215 16.445 11.2799 16.445 10.904V8.58487C16.445 5.59654 14.0158 3.1582 11.0183 3.1582C8.02083 3.1582 5.59167 5.59654 5.59167 8.58487V10.904C5.59167 11.2799 5.4175 11.9215 5.225 12.2515L4.29917 13.7824C3.9325 14.3965 3.85 15.0749 4.07917 15.6982C4.29917 16.3124 4.82167 16.789 5.5 17.0182C7.27833 17.6232 9.14833 17.9165 11.0183 17.9165C12.8883 17.9165 14.7583 17.6232 16.5367 17.0274C17.1783 16.8165 17.6733 16.3307 17.9117 15.6982C18.15 15.0657 18.0858 14.369 17.7283 13.7824Z" fill="#64748B" />
                        <path d="M13.0616 3.5435C12.4291 3.296 11.7416 3.1585 11.0174 3.1585C10.3024 3.1585 9.61492 3.28683 8.98242 3.5435C9.37659 2.801 10.1558 2.3335 11.0174 2.3335C11.8883 2.3335 12.6583 2.801 13.0616 3.5435Z" fill="#64748B" />
                        <path d="M13.5932 18.8427C13.2082 19.906 12.1907 20.6668 10.9991 20.6668C10.2749 20.6668 9.5599 20.3735 9.05573 19.851C8.7624 19.576 8.5424 19.2093 8.41406 18.8335C8.53323 18.8518 8.6524 18.861 8.78073 18.8793C8.99156 18.9068 9.21156 18.9343 9.43156 18.9527C9.95406 18.9985 10.4857 19.026 11.0174 19.026C11.5399 19.026 12.0624 18.9985 12.5757 18.9527C12.7682 18.9343 12.9607 18.9252 13.1441 18.8977C13.2907 18.8793 13.4374 18.861 13.5932 18.8427Z" fill="#64748B" />
                        <circle cx="16.621" cy="4.87878" r="3.12097" fill="#10B981" stroke="white" />
                    </svg>
                </Badge>}
        </span>

        {notification && count !== 0 ?
            <ul className="dropdown-menu notifications ">
                <div className="moderate-title" style={{ marginBottom: "12px" }}>
                  {t('navbar.notifcation.notifications')}   
                </div>
                {notification.content && notification.content.map((notif: any, index: number) => {
                    return <a onClick={() => { readNotificationsVideo(notif) }} key={index} style={{ borderBottom: "2px solid #8C8D96" }}>
                        <div className='d-flex card-notif' >
                            <div className="rounded" style={{ background: "#DEF5E0" }}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.0199 20.5299C9.68987 20.5299 7.35987 20.1599 5.14987 19.4199C4.30987 19.1299 3.66987 18.5399 3.38987 17.7699C3.09987 16.9999 3.19987 16.1499 3.65987 15.3899L4.80987 13.4799C5.04987 13.0799 5.26987 12.2799 5.26987 11.8099V8.91992C5.26987 5.19992 8.29987 2.16992 12.0199 2.16992C15.7399 2.16992 18.7699 5.19992 18.7699 8.91992V11.8099C18.7699 12.2699 18.9899 13.0799 19.2299 13.4899L20.3699 15.3899C20.7999 16.1099 20.8799 16.9799 20.5899 17.7699C20.2999 18.5599 19.6699 19.1599 18.8799 19.4199C16.6799 20.1599 14.3499 20.5299 12.0199 20.5299ZM12.0199 3.66992C9.12987 3.66992 6.76987 6.01992 6.76987 8.91992V11.8099C6.76987 12.5399 6.46987 13.6199 6.09987 14.2499L4.94987 16.1599C4.72987 16.5299 4.66987 16.9199 4.79987 17.2499C4.91987 17.5899 5.21987 17.8499 5.62987 17.9899C9.80987 19.3899 14.2399 19.3899 18.4199 17.9899C18.7799 17.8699 19.0599 17.5999 19.1899 17.2399C19.3199 16.8799 19.2899 16.4899 19.0899 16.1599L17.9399 14.2499C17.5599 13.5999 17.2699 12.5299 17.2699 11.7999V8.91992C17.2699 6.01992 14.9199 3.66992 12.0199 3.66992Z" fill="#22BB33" />
                                    <path d="M13.8796 3.93969C13.8096 3.93969 13.7396 3.92969 13.6696 3.90969C13.3796 3.82969 13.0996 3.76969 12.8296 3.72969C11.9796 3.61969 11.1596 3.67969 10.3896 3.90969C10.1096 3.99969 9.80963 3.90969 9.61963 3.69969C9.42963 3.48969 9.36963 3.18969 9.47963 2.91969C9.88963 1.86969 10.8896 1.17969 12.0296 1.17969C13.1696 1.17969 14.1696 1.85969 14.5796 2.91969C14.6796 3.18969 14.6296 3.48969 14.4396 3.69969C14.2896 3.85969 14.0796 3.93969 13.8796 3.93969Z" fill="#22BB33" />
                                    <path d="M12.0195 22.8096C11.0295 22.8096 10.0695 22.4096 9.36953 21.7096C8.66953 21.0096 8.26953 20.0496 8.26953 19.0596H9.76953C9.76953 19.6496 10.0095 20.2296 10.4295 20.6496C10.8495 21.0696 11.4295 21.3096 12.0195 21.3096C13.2595 21.3096 14.2695 20.2996 14.2695 19.0596H15.7695C15.7695 21.1296 14.0895 22.8096 12.0195 22.8096Z" fill="#22BB33" />
                                </svg>
                            </div>
                            <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                <div className="me-5">
                                    <h6 className="mb-0"> {t(`navbar.notifcation.${notif.message}`)}</h6>
                                    <small className="text-muted">{convertDate(notification.updatedAt)}</small>
                                </div>
                            </div>
                        </div>
                    </a>
                })
                }
            </ul>
            : <ul className="dropdown-menu notifications ">
                <small className="text-muted"> {t('navbar.notifcation.noNotifications')} </small>
            </ul>
        }

        <BootstrapDialog
            onClose={handleClose}
            open={open}
            TransitionComponent={Transition}
            keepMounted
            sx={{ '& .MuiDialog-paper': { width: '100%' } }}
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
               {t('navbar.notifcation.listingVideo')} 
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={(theme) => ({
position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[800],
                    '&:hover': { backgroundColor: theme.palette.grey[400] }
                })}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent>
                <div className="card border-16 d-flex align-items-center justify-content-center" style={{ width: '100%', height: 'auto', minHeight: "200px", position: 'relative' }}>
                    <div className="padd-24">
                        {videoUrl == null ? (
                            <div className="spinner-border text-primary size-50" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        ) : (
                            <>
                                {isVideoLoading && (
                                    <div className="spinner-border text-primary size-50" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                )}
                                <video
                                    width="100%"
                                    height="auto"
                                    controls
                                    muted
                                    onCanPlay={() => setIsVideoLoading(false)} // ← plus fiable
                                    style={{ display: isVideoLoading ? 'none' : 'block' }}
                                >
                                    <source src={videoUrl.url} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </>
                        )}
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <button onClick={HandleDownoald} className={`button-reset back-6366F1 color-FFFFFF  border-6366F1 height-44 padd-15 mb-3 marg-right-16`}>
                    <svg width="15" height="14" className="marg-right-5" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.7109 14.0273H3.28906C2.54962 14.0265 1.84072 13.7323 1.31786 13.2095C0.794994 12.6866 0.500868 11.9777 0.5 11.2383V2.81641C0.500868 2.07697 0.794994 1.36806 1.31786 0.8452C1.84072 0.322338 2.54962 0.0282121 3.28906 0.0273438H11.7109C12.4504 0.0282121 13.1593 0.322338 13.6821 0.8452C14.205 1.36806 14.4991 2.07697 14.5 2.81641V11.2383C14.4991 11.9777 14.205 12.6866 13.6821 13.2095C13.1593 13.7323 12.4504 14.0265 11.7109 14.0273ZM3.28906 1.12109C2.83959 1.1216 2.40868 1.30038 2.09086 1.6182C1.77303 1.93602 1.59426 2.36694 1.59375 2.81641V11.2383C1.59426 11.6878 1.77303 12.1187 2.09086 12.4365C2.40868 12.7543 2.83959 12.9331 3.28906 12.9336H11.7109C12.1604 12.9331 12.5913 12.7543 12.9091 12.4365C13.227 12.1187 13.4057 11.6878 13.4062 11.2383V2.81641C13.4057 2.36694 13.227 1.93602 12.9091 1.6182C12.5913 1.30038 12.1604 1.1216 11.7109 1.12109H3.28906Z" fill="white" />
                        <path d="M7.5 8.89625C7.35496 8.89625 7.21586 8.83863 7.1133 8.73607C7.01074 8.63352 6.95312 8.49442 6.95312 8.34937V3.26563C6.95312 3.12058 7.01074 2.98148 7.1133 2.87893C7.21586 2.77637 7.35496 2.71875 7.5 2.71875C7.64504 2.71875 7.78414 2.77637 7.8867 2.87893C7.98926 2.98148 8.04688 3.12058 8.04688 3.26563V8.34937C8.04688 8.49442 7.98926 8.63352 7.8867 8.73607C7.78414 8.83863 7.64504 8.89625 7.5 8.89625Z" fill="white" />
                        <path d="M7.49996 9.28564C7.37856 9.286 7.2583 9.26229 7.14612 9.21587C7.03395 9.16945 6.93209 9.10125 6.84645 9.01521L4.72566 6.8947C4.62308 6.79212 4.56546 6.65299 4.56546 6.50792C4.56546 6.36285 4.62308 6.22373 4.72566 6.12115C4.82824 6.01857 4.96737 5.96094 5.11244 5.96094C5.25751 5.96094 5.39664 6.01857 5.49922 6.12115L7.49996 8.12216L9.5007 6.12115C9.60328 6.01857 9.74241 5.96094 9.88748 5.96094C10.0326 5.96094 10.1717 6.01857 10.2743 6.12115C10.3768 6.22373 10.4345 6.36285 10.4345 6.50792C10.4345 6.65299 10.3768 6.79212 10.2743 6.8947L8.15348 9.01521C8.06783 9.10125 7.96598 9.16945 7.8538 9.21587C7.74163 9.26229 7.62136 9.286 7.49996 9.28564ZM9.88762 11.2801H5.1123C4.96726 11.2801 4.82816 11.2225 4.72561 11.1199C4.62305 11.0174 4.56543 10.8783 4.56543 10.7332C4.56543 10.5882 4.62305 10.4491 4.72561 10.3465C4.82816 10.244 4.96726 10.1863 5.1123 10.1863H9.88762C10.0327 10.1863 10.1718 10.244 10.2743 10.3465C10.3769 10.4491 10.4345 10.5882 10.4345 10.7332C10.4345 10.8783 10.3769 11.0174 10.2743 11.1199C10.1718 11.2225 10.0327 11.2801 9.88762 11.2801Z" fill="white" />
                    </svg>
                     {t('propertiesPage.download')} 
                </button>
            </DialogActions>
        </BootstrapDialog>

    </>)
}

export default Notifications